import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=53dcbf59&scoped=true"
import script from "./RuleForm.vue?vue&type=script&lang=js"
export * from "./RuleForm.vue?vue&type=script&lang=js"
import style0 from "./RuleForm.vue?vue&type=style&index=0&id=53dcbf59&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcbf59",
  null
  
)

export default component.exports